(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name ShiftsService
     *@description
     *Servicio del calendario de turnos
     */

    angular
        .module('appback')
        .factory('ShiftsService', ShiftsService);

    ShiftsService.$inject = ["$http"];

    function ShiftsService($http) {

        var service = {
            GetGrid: GetGrid,
            GetEmployeeShifts: GetEmployeeShifts,
            GetShiftTypes: GetShiftTypes,
            GetDepartments: GetDepartments,
            GetProductionLines: GetProductionLines,
            GetPersonal: GetPersonal,
            SaveShift: SaveShift,
            SaveShiftRange: SaveShiftRange,
            UpdateShiftLine: UpdateShiftLine,
            UpdateShiftWorkday: UpdateShiftWorkday,
            UpdateSupervisor: UpdateSupervisor,
            GetDistinguishers: GetDistinguishers,
            UpdateDistinguisher: UpdateDistinguisher,
            GenerateMonth: GenerateMonth,
            DeleteMonth: DeleteMonth,
            GetVacationDays: GetVacationDays,
            ImportVacationsFromSap: ImportVacationsFromSap,
            DefineVacations: DefineVacations,
            ApplyVacations: ApplyVacations,
            ImportExcel: ImportExcel
        };

        function GetGrid(params) {
            return $http.get('/backend/shifts/get-grid', {
                params: params
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetEmployeeShifts(params) {
            return $http.get('/backend/shifts/get-employee-shifts', {
                params: params
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetShiftTypes() {
            return $http.get('/backend/shifts/get-shift-types', {
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetDepartments() {
            return $http.get('/backend/shifts/get-departments', {
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetProductionLines() {
            return $http.get('/backend/shifts/get-production-lines', {
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetPersonal() {
            return $http.get('/backend/shifts/get-personal', {
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function SaveShift(payload) {
            return $http.post('/backend/shifts/save-shift', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function SaveShiftRange(payload) {
            return $http.post('/backend/shifts/save-shift-range', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function UpdateShiftLine(payload) {
            return $http.post('/backend/shifts/update-shift-line', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function UpdateShiftWorkday(payload) {
            return $http.post('/backend/shifts/update-shift-workday', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function UpdateSupervisor(payload) {
            return $http.post('/backend/shifts/update-supervisor', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetDistinguishers(params) {
            return $http.get('/backend/shifts/get-distinguishers', {
                params: params
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function UpdateDistinguisher(payload) {
            return $http.post('/backend/shifts/update-distinguisher', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GenerateMonth(payload) {
            return $http.post('/backend/shifts/generate-month', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function DeleteMonth(payload) {
            return $http.post('/backend/shifts/delete-month', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function GetVacationDays() {
            return $http.get('/backend/shifts/get-vacation-days', {
                headers: {}
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function ImportVacationsFromSap() {
            return $http.post('/backend/shifts/import-vacations-from-sap', {}).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function DefineVacations(payload) {
            return $http.post('/backend/shifts/define-vacations', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function ApplyVacations(payload) {
            return $http.post('/backend/shifts/apply-vacations', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function ImportExcel(file, month, year) {

            var formData = new FormData();

            formData.append('file', file);
            formData.append('month', month);
            formData.append('year', year);

            // Content-Type undefined: el navegador pone multipart/form-data con
            // su boundary. El token CSRF lo añade la configuración global.
            return $http.post('/backend/shifts/import-excel', formData, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        return service;
    }
})();
